<template>
  <!--Inclusion Detail -->

  <div class="landing-diversity idea">
    <hero :props="inclusionDetail.elements" :heroHome="false" :lightbox="false"></hero>

    <template v-if="inclusionDetail.elements">
      <section
        class="content-section col-xs-12 no-gutters"
        id="section"
        v-in-viewport=""
        v-if="inclusionDetail.elements.intro_headline.value"
      >
        <div class="inside">
          <h2>{{ inclusionDetail.elements.intro_headline.value }}</h2>
          <div
            class="description"
            v-html="inclusionDetail.elements.intro_paragraph.value"
          ></div>
          <div class="steps" v-html="inclusionDetail.elements.intro_steps.value"></div>
        </div>
      </section>
    </template>

    <template v-if="inclusionDetail.elements">
      <section
        class="content-section sub-committe-container"
        v-in-viewport=""
        v-if="inclusionDetail.elements.sc_headline.value"
      >
        <div class="inside">
          <h2>{{ inclusionDetail.elements.sc_headline.value }}</h2>
          <div
            class="description"
            v-html="inclusionDetail.elements.sc_description.value"
          ></div>

          <!-- Tabs -->
          <tabs transitionName="fade">
            <tab
              :title="modularContent[sub_committee].elements.tab_label.value"
              class="sub-committes"
              v-for="(sub_committee, key) in inclusionDetail.elements.sub_committees
                .value"
              v-bind:key="key"
            >
              <div class="inside">
                <div class="image">
                  <img
                    :src="modularContent[sub_committee].elements.image.value[0].url"
                    alt="modularContent[sub_committee].elements.subcommittee.value"
                  />
                </div>
                <div class="content">
                  <div class="inner">
                    <h3>
                      {{ modularContent[sub_committee].elements.tab_label.value }}
                    </h3>
                    <div
                      v-html="modularContent[sub_committee].elements.description.value"
                    ></div>

                    <template
                      v-if="
                        modularContent[sub_committee].elements.button_link != undefined &&
                        modularContent[sub_committee].elements.button_link.value != ''
                      "
                    >
                      <a
                        class="btn_orange"
                        :href="modularContent[sub_committee].elements.button_link.value"
                        target="_blank"
                        >{{
                          modularContent[sub_committee].elements.button_label.value
                        }}</a
                      >
                    </template>
                  </div>
                </div>
              </div>
            </tab>
          </tabs>
        </div>
      </section>
    </template>

    <!-- Monthly Topics Section -->
    <template v-if="monthlyTopics.length > 0">
      <section
        class="content-section topics-section"
        v-in-viewport=""
        v-if="inclusionDetail.elements.mt_headline.value"
      >
        <div class="inside">
          <h2>{{ inclusionDetail.elements.mt_headline.value }}</h2>
          <div
            class="description"
            v-html="inclusionDetail.elements.mt_description.value"
          ></div>

          <!-- Highlighted Topic (Current) -->
          <div class="highlighted-topic" v-if="monthlyTopics[0].elements">
            <div class="image">
              <img
                :src="monthlyTopics[0].elements.image.value[0].url"
                :alt="monthlyTopics[0].elements.title.value"
              />
            </div>
            <div class="info">
              <span class="month-name">{{
                getMonthString(monthlyTopics[0].elements.date.value)
              }}</span>
              <span class="topic-name">{{ monthlyTopics[0].elements.title.value }}</span>
              <div v-html="monthlyTopics[0].elements.content.value" class="content"></div>
            </div>
          </div>

          <!-- Upcoming Topics -->
          <div class="topics" v-if="monthlyTopics.length > 1">
            <div
              class="topic"
              :id="'c' + index"
              v-for="(topic, index) in monthlyTopics.slice(1)"
              v-bind:key="index"
            >
              <div class="inner">
                <span class="month-name">{{
                  getMonthString(topic.elements.date.value)
                }}</span>
                <span class="topic-name">{{ topic.elements.title.value }}</span>
                <div class="content">{{ topic.elements.subtitle.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>

    <!-- Breakthrough session - Section -->
    <section
      class="content-section breakthrough"
      v-in-viewport=""
      v-if="
        inclusionDetail.elements != undefined &&
        inclusionDetail.elements.bs_background.value[0] != undefined
      "
      :style="setBackgroundImage(inclusionDetail.elements.bs_background.value[0].url)"
    >
      <div class="content" v-html="inclusionDetail.elements.bs_description.value"></div>
      <template
        v-if="
          inclusionDetail.elements.bs_url != undefined &&
          inclusionDetail.elements.bs_url.value != ''
        "
      >
        <a
          class="btn_orange"
          :href="inclusionDetail.elements.bs_url.value"
          target="_blank"
          >{{ inclusionDetail.elements.bs_button_label.value }}</a
        >
      </template>
    </section>

    <!-- Team Section -->
    <template v-if="inclusionDetail.elements">
      <section
        class="content-section team-container"
        v-in-viewport=""
        v-if="inclusionDetail.elements.team_headline.value"
      >
        <div class="inside">
          <h2>
            {{ inclusionDetail.elements.team_headline.value }}
          </h2>
          <div
            class="description"
            v-if="inclusionDetail.elements.team_description.value"
            v-html="inclusionDetail.elements.team_description.value"
          ></div>

          <!-- Members list -->
          <div class="team">
            <div
              class="box-member"
              :id="'c' + index"
              v-for="(box, index) in team"
              v-bind:key="index"
            >
              <div class="inner" :style="putInOrder(box.image.value[0].url)">
                <div class="overlay" :style="backgroundRGB(box.color.value)">
                  <span class="name">{{ box.name.value }}</span>
                  <span class="position">{{ box.position.value }}</span>
                  <span class="bio">{{ box.bio.value }}</span>
                </div>
                <img :src="box.image.value[0].url" :alt="box.image.value[0].name" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </template>

    <!-- Related Works -->
    <section class="content-works col-xs-12 no-gutters">
      <div class="inside">
        <h2 class="text-center container-fluid" v-in-viewport="">Case Studies</h2>
        <p class="related container">
          Big ideas drive innovation and are essential in engaging customers. Big ideas
          need big execution, too. That’s why our team is organized and focused on the
          four areas innovative companies need most:
        </p>
        <boxes-wrapper
          :boxes="relatedWorks"
          :boxlimit="3"
          :showViewAll="true"
        ></boxes-wrapper>
      </div>
    </section>

    <!-- Insights, Commentary and News  -->
    <section class="content-articles insights" v-in-viewport="">
      <div class="inside">
        <h2 class="text-center" v-in-viewport="">Insights, Commentary and News</h2>
        <articles-wrapper
          :boxes="relatedArticles"
          :isHome="true"
          :boxlimit="4"
          :pathRoute="'/words'"
          :showCategory="true"
          :showViewAll="true"
        ></articles-wrapper>
      </div>
    </section>
  </div>
  <!-- End IDEA Team -->
</template>

<script>
import apiConnection from "../mixins/apiConnection.js";
import seoModule from "../mixins/seoModule.js";
import common from "../mixins/common.js";
import boxesWrapperInclusion from "../components/boxes-wrapper-inclusion.vue";
import articlesWrapper from "../components/articles-wrapper.vue";
import moreList from "../components/more-list.vue";
import hero from "../components/hero.vue";
import { Tabs, Tab } from "vue-tmn-tabs";
import VueCollapse from "vue2-collapse";

require("../assets/img/plus-button-orange.svg");
require("../assets/img/minus-button.svg");

export default {
  name: "Inclusion-detail",
  data() {
    return {
      relatedWorks: [],
      relatedArticles: [],
      inclusionDetail: [],
      modularContent: [],
      team: [],
      monthlyTopics: [],
    };
  },
  async created() {
    let url = this.$route.path.split("/");
    this.getInclusionDetails(url[2]);
  },
  async mounted() {
    var x = $(".VueCarousel-dot-container").width();
    $(".VueCarousel-navigation-prev").css("left", "calc(50% - " + (x / 2 + 20) + "px )");
    $(".VueCarousel-navigation-next").css("right", "calc(50% - " + (x / 2 + 20) + "px )");

    if ($(".VueCarousel-dot-container").children().length < 2) {
      $(".VueCarousel-navigation").hide();
    } else {
      $(".VueCarousel-navigation").show();
    }
  },
  methods: {
    beforeOpen: function (id) {
      document.getElementById(id).classList.add("active");
    },
    beforeClose: function (id) {
      document.getElementById(id).classList.remove("active");
    },
    putInOrder: function (index) {
      return "background-image:url(" + index + ")";
    },
    getMonthString: function (date) {
      var d = new Date(date);
      var months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ];
      return months[d.getMonth()];
    },
    backgroundRGB: function (hex) {
      "use strict";
      if (hex.charAt(0) === "#") {
        hex = hex.substr(1);
      }
      if (hex.length < 2 || hex.length > 6) {
        return false;
      }
      var values = hex.split(""),
        r,
        g,
        b;

      if (hex.length === 2) {
        r = parseInt(values[0].toString() + values[1].toString(), 16);
        g = r;
        b = r;
      } else if (hex.length === 3) {
        r = parseInt(values[0].toString() + values[0].toString(), 16);
        g = parseInt(values[1].toString() + values[1].toString(), 16);
        b = parseInt(values[2].toString() + values[2].toString(), 16);
      } else if (hex.length === 6) {
        r = parseInt(values[0].toString() + values[1].toString(), 16);
        g = parseInt(values[2].toString() + values[3].toString(), 16);
        b = parseInt(values[4].toString() + values[5].toString(), 16);
      } else {
        return false;
      }
      //return [r, g, b];
      return `background-color:rgba(${r},${g},${b},0.7)`;
    },
  },
  components: {
    "boxes-wrapper": boxesWrapperInclusion,
    "articles-wrapper": articlesWrapper,
    "more-list": moreList,
    hero: hero,
    Tab,
    Tabs,
    VueCollapse,
  },
  mixins: [apiConnection, seoModule, common],
};
</script>



// WEBPACK FOOTER //
// InclusionSections.vue?5797c1e2